/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TimelineContent } from '../../models/timeline-content';
import { TimelineContentApiRespModel } from '../../models/timeline-content-api-resp-model';

export interface ApiMasterTimelineContentEditPost$Params {
      body?: TimelineContent
}

export function apiMasterTimelineContentEditPost(http: HttpClient, rootUrl: string, params?: ApiMasterTimelineContentEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<TimelineContentApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterTimelineContentEditPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TimelineContentApiRespModel>;
    })
  );
}

apiMasterTimelineContentEditPost.PATH = '/api/Master/TimelineContent/Edit';
